<div class="modal-header">
  <h5 class="modal-title">
    {{ 'julia.action_preview.title' | translate }}: {{ (actionRequest.action_type ? ('julia.action_type.' + actionRequest.action_type) : 'julia.action_request.default_message') | translate }}
  </h5>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <ng-container #previewContainer></ng-container>
  <div *ngIf="!previewComponentExists" class="text-center py-8">
    <p class="text-gray-500 mb-4">{{ 'julia.action_preview.no_preview_available' | translate }}</p>
    <pre class="text-left bg-gray-50 p-4 rounded border border-gray-200 text-sm overflow-x-auto">{{ actionRequest.preview_data || actionRequest.action_data | json }}</pre>
  </div>
</div>

<div class="modal-footer">
  <button type="button" 
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50 transition-colors"
          (click)="close()">
    {{ 'julia.action_preview.close' | translate }}
  </button>
  <button type="button" 
          class="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-red-600 rounded hover:bg-red-700 transition-colors"
          (click)="deny()">
    {{ 'julia.action_preview.deny' | translate }}
  </button>
  <button type="button" 
          class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-blue-600 rounded hover:bg-blue-700 transition-colors"
          (click)="approve()">
    {{ 'julia.action_preview.approve' | translate }}
  </button>
</div>
